import React, { FC } from 'react';
import classNames from 'classnames';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

interface IOption {
  [key: string]: any;
}

interface IProps {
  list: IOption[];
  onClick: (option: IOption) => void;
  label: string;
  trackBy: string;
  value: IOption;
  textSize?: 'md';
}

const Options: FC<IProps> = ({
  list = [],
  onClick = () => {},
  trackBy,
  label,
  value,
  textSize,
}) => (
  <ul className={css.options}>
    {list.map((item) => (
      <li className={css.options__item} key={item[trackBy]}>
        <button
          className={classNames(css.options__button, {
            [css['options__button--active']]: value && value[trackBy] === item[trackBy],
          })}
          onClick={() => onClick(item)}
        >
          <span className={css.options__buttonContent}>
            {item.icon && (
              <span className={css.options__buttonIcon}>
                <Icon id={item.icon} />
              </span>
            )}
            <span
              className={classNames(css.options__buttonText, {
                [css[`options__buttonText_size_${textSize}`]]: textSize,
              })}
            >
              {item[label]}
            </span>
          </span>
        </button>
      </li>
    ))}
  </ul>
);

export default Options;
